export class ProductsClassVariable {
    constructor({
                    //attributes
                    id = null,
                    company_id = null,
                    name = '',
                    type = '',
                    products_class_id = null,
                    is_dependent = false,
                    dependency = null,
                    dependency_value = null,
                    dependency_class = null,
                    dependency_operator = null,
                    default_formula_id = null,
                    dependency_conditions = [],
                    preselect_conditions = [],
                    formula_conditions = [],
                    formula_id = null,
                    hidden = 0,
                    required = 0,
                    direct_products_category_id = null,
                    direct_products_category_ids = [],
                    min_max_settings = { 
                        max_type: null,
                        min_type: null,
                        min_value: null,
                        max_value: null
                    },

                    created_at = new Date(),
                    updated_at = new Date(),
                    deleted_at = null,

                    //relations
                    options = []
                } = {}) {

        //fill attributes

        this.id = id;
        this.company_id = company_id;
        this.name = name;
        this.type = type;
        this.products_class_id = products_class_id;
        this.is_dependent = is_dependent;
        this.dependency = dependency;
        this.dependency_value = dependency_value;
        this.dependency_class = dependency_class;
        this.dependency_operator = dependency_operator;
        this.default_formula_id = default_formula_id;
        this.dependency_conditions = dependency_conditions;
        this.preselect_conditions = preselect_conditions;
        this.formula_conditions = formula_conditions;
        this.formula_id = formula_id
        this.hidden = hidden;
        this.required = required;
        this.direct_products_category_id = direct_products_category_id;
        this.direct_products_category_ids = direct_products_category_ids;
        this.min_max_settings = min_max_settings ?? {
            max_type: null,
            min_type: null,
            min_value: null,
            max_value: null
        };
        
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;

        this.options = options;
    }

}

export function createProductsClassVariable(data={}) {
    return Object.freeze(new ProductsClassVariable(data));
}